import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ChatbotService {
    public chatbotURL = 'https://api.api.ai/v1/';
    public accessToken = '0eb410859caa4a499fb5d21d3dfab45a';

    httpOptions = {
        headers: new HttpHeaders(
            {
                'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.accessToken
            }
        )
    };
    constructor(private http: HttpClient) {
    }
    getResponse(queryString) {
        let url = this.chatbotURL + 'query?v=20150910'
        let body = {
            query: queryString,
            lang: 'en',
            sessionId: 'randomSession'
        }
        return this.http.post<any>(url, body);
    }
}
